import { render, staticRenderFns } from "./Custom.vue?vue&type=template&id=8a7a8e7e&scoped=true&"
import script from "./Custom.vue?vue&type=script&lang=js&"
export * from "./Custom.vue?vue&type=script&lang=js&"
import style0 from "./Custom.vue?vue&type=style&index=0&id=8a7a8e7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a7a8e7e",
  null
  
)

export default component.exports